import React, {memo} from "react";
import styles from "./styles.module.scss";
import {ChatModel} from "@/app/api/chat";
import LazyImage from "@/app/components/lazy_image";
import classNames from "classnames";
import Space from "@/app/components/space";
import {TextBold20, TextMedium12, TextMedium16, ThirtyText} from "@/app/components/texts";
import {s} from "@/app/utils/s";
import {t} from "i18next";

interface Props {
  item: ChatModel,
  onSelectChat: () => void,
  unreadMessageCount: number
}

const ChatItem: React.FC<Props> = ({item, onSelectChat, unreadMessageCount}) => {
  return (
    <div className={styles.chatItems} onClick={onSelectChat}>
      <div className={styles.avatars}>
        {item.participants.map((user, index) => {
          return user.imageLink !== null ? <LazyImage url={user.imageLink} alt={user.username}
                                                      key={index}
                                                      className={classNames(styles.avatar, styles[`z${item.participants.length - index}`]
                                                      )}/> :
            <div className={classNames(styles.avatar, styles.empty, styles[`z${item.participants.length - index}`]
            )} key={index}>
              <ThirtyText text={user?.username?.charAt(0) ?? "U"}/>
            </div>
        })}
      </div>
      <Space.W16/>
      <div className={styles.infoBlock}>
        <TextMedium16 text={item.participants.map((user, index) => user.username).join(', ')}
                      className={styles.userNames}/>
        <TextMedium16 text={item.lastMessageText ?? t(s.noMessages)} className={styles.lastMessage}/>
      </div>
      {unreadMessageCount !== 0 && <div className={styles.countWrapper}>
          <div className={classNames(styles.count, {[styles.active]: true})}>{<TextMedium12
            text={unreadMessageCount.toString()}/>}</div>
      </div>}
    </div>
  );
};

export default memo(ChatItem);